import { render, staticRenderFns } from "./FormInputTextWidget.vue?vue&type=template&id=1ba335e4&"
import script from "./FormInputTextWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputTextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports